import {withTranslation} from '@wix/yoshi-flow-editor'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderExpired as Presentation} from './order-expired'
import {OrderExpiredRuntimeProps} from './interfaces'

const mapRuntime = ({actions: {navigateToMainPage}}: DetailsPageAppProps) => ({
  navigateToMainPage,
})

export const OrderExpired = connect<{}, OrderExpiredRuntimeProps>(mapRuntime)(withTranslation()(Presentation))
export * from './interfaces'
